import React, { useEffect, useState } from 'react';
import '../styles/Header.css';
import '../styles/DiwaliCampaign.css';
import GoogleRatingBadge from './GoogleRatingBadge';
import DiwaliFireworks from './DiwaliFireworks';

const CITY_HUBS = [
  { href: '/coimbatore-taxi', label: 'Coimbatore' },
  { href: '/chennai-taxi', label: 'Chennai' },
  { href: '/madurai-taxi', label: 'Madurai' },
  { href: '/trichy-taxi', label: 'Trichy' },
  { href: '/bangalore-taxi', label: 'Bangalore' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCitiesOpen, setIsCitiesOpen] = useState(false);
  const [isRoutesOpen, setIsRoutesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsCitiesOpen(false);
    setIsRoutesOpen(false);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsCitiesOpen(false);
    setIsRoutesOpen(false);
  };

  useEffect(() => {
    if (!isMenuOpen) return undefined;
    const previousBody = document.body.style.overflow;
    const previousRoot = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousBody;
      document.documentElement.style.overflow = previousRoot;
    };
  }, [isMenuOpen]);

  return (
    <header className="site-header header-style-1 mobile-sider-drawer-menu light-hdr">
      <div className="header-middle-wraper sticky-header">
        <div className="header-middle main-bar">
          <div className="logo-header">
            <div className="logo-header-inner logo-header-one">
              <a href="/">
                <img src="/images/logo-light.png" alt="Easy Drop Taxi Logo" className="header-logo" />
              </a>
              <DiwaliFireworks />
            </div>
          </div>

          <div className="header-google-slot">
            <GoogleRatingBadge />
          </div>

          <div className="header-info-wraper">
            <div className="main-bar-wraper navbar-expand-lg">
              <div className="header-bottom">
                <div className="container-block clearfix">
                  <div className="navigation-bar">
                    <div className="nav-animation header-nav navbar-collapse collapse">
                      <ul className="nav navbar-nav">
                        <li><a href="/" onClick={closeMenu}>Home</a></li>
                        <li><a href="/tariff" onClick={closeMenu}>Tariff</a></li>
                        <li><a href="/taxi-routes" onClick={closeMenu}>Routes</a></li>
                        <li
                          className={`nav-item-has-children ${isCitiesOpen ? 'is-open' : ''}`}
                          onMouseEnter={() => setIsCitiesOpen(true)}
                          onMouseLeave={() => setIsCitiesOpen(false)}
                        >
                          <button
                            type="button"
                            className="nav-cities-trigger"
                            aria-expanded={isCitiesOpen}
                            aria-haspopup="true"
                            onClick={() => setIsCitiesOpen((open) => !open)}
                          >
                            Cities
                          </button>
                          <ul className="nav-submenu" hidden={!isCitiesOpen}>
                            {CITY_HUBS.map((hub) => (
                              <li key={hub.href}>
                                <a href={hub.href} onClick={closeMenu}>{hub.label} Taxi</a>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li><a href="/services" onClick={closeMenu}>Services</a></li>
                        <li><a href="/about" onClick={closeMenu}>About</a></li>
                        <li><a href="/blog" onClick={closeMenu}>Blog</a></li>
                        <li><a href="/contact" onClick={closeMenu}>Contact</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            id="mobile-side-drawer"
            className={`navbar-toggler ${isMenuOpen ? '' : 'collapsed'}`}
            type="button"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar icon-bar-first"></span>
            <span className="icon-bar icon-bar-two"></span>
            <span className="icon-bar icon-bar-three"></span>
          </button>
        </div>

        {isMenuOpen && (
          <div className="mobile-menu show" role="dialog" aria-modal="true" aria-label="Site navigation">
            <div className="mobile-menu-head">
              <a href="/" className="mobile-menu-logo" onClick={closeMenu}>
                <img src="/images/logo-light.png" alt="Easy Drop Taxi Logo" />
              </a>
              <button
                type="button"
                className="mobile-menu-close"
                onClick={closeMenu}
                aria-label="Close navigation"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <GoogleRatingBadge />
            </div>
            <ul className="nav navbar-nav mobile-nav">
              <li><a href="/" onClick={closeMenu}>Home</a></li>
              <li><a href="/tariff" onClick={closeMenu}>Tariff</a></li>
              <li className={`mobile-nav-routes ${isRoutesOpen ? 'is-open' : ''}`}>
                <button
                  type="button"
                  className="mobile-nav-routes-trigger"
                  aria-expanded={isRoutesOpen}
                  onClick={() => setIsRoutesOpen((open) => !open)}
                >
                  <span>Routes</span>
                  <span className="mobile-nav-chevron" aria-hidden="true"></span>
                </button>
                {isRoutesOpen ? (
                  <ul className="mobile-nav-submenu">
                    {CITY_HUBS.map((hub) => (
                      <li key={hub.href}>
                        <a href={hub.href} onClick={closeMenu}>{hub.label} Taxi</a>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
              <li><a href="/services" onClick={closeMenu}>Services</a></li>
              <li><a href="/about" onClick={closeMenu}>About</a></li>
              <li><a href="/blog" onClick={closeMenu}>Blog</a></li>
              <li><a href="/contact" onClick={closeMenu}>Contact</a></li>
            </ul>
            <div className="mobile-menu-foot">
              <a className="mobile-menu-fare" href="/#home-booking" onClick={closeMenu}>
                Get Fare Estimate
              </a>
            </div>
          </div>
        )}

        {isMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMenu}></div>
        )}
      </div>
    </header>
  );
};

export default Header;
